import cn from 'classnames';
import React from 'react';
import { Setter } from 'libs/end-to-end/src/ui-types';

export const SimpleSlider = <T extends string>(props: {
  currentValue: T;
  selectableValues: T[];
  getRenderValue?: (value: T) => string;
  onChange: Setter<T>;
}) => {
  const { currentValue, selectableValues, onChange, getRenderValue } = props;

  return (
    <div className="bg-white w-fit flex justify-start font-sans rounded-3xl">
      {selectableValues.map((value) => {
        const isSelected = value === currentValue;
        return (
          <button
            key={value}
            className={cn('px-4 py-2 text-sm font-sans font-bold', {
              'text-white bg-secondary rounded-3xl': isSelected,
              '': !isSelected,
            })}
            onClick={() => onChange(value)}
          >
            {getRenderValue ? getRenderValue(value) : value}
          </button>
        );
      })}
    </div>
  );
};
